module.exports = __webpack_public_path__ + "img/hero-main-1-eng.b9e6f6b4.png";